var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9999 1.60156C8.44173 1.60156 8.7999 1.95973 8.7999 2.40156V13.6016C8.7999 14.0434 8.44173 14.4016 7.9999 14.4016C7.55807 14.4016 7.1999 14.0434 7.1999 13.6016V2.40156C7.1999 1.95973 7.55807 1.60156 7.9999 1.60156Z",
    fill: "#8993A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63422 8.23588C2.94664 7.92346 3.45317 7.92346 3.76559 8.23588L7.9999 12.4702L12.2342 8.23588C12.5466 7.92346 13.0532 7.92346 13.3656 8.23588C13.678 8.5483 13.678 9.05483 13.3656 9.36725L8.56559 14.1672C8.25317 14.4797 7.74664 14.4797 7.43422 14.1672L2.63422 9.36725C2.3218 9.05483 2.3218 8.5483 2.63422 8.23588Z",
    fill: "#8993A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sort_arrow.141c40e2c6217b040ad191127b021c61.svg";
export { ForwardRef as ReactComponent };